/**
 * @generated SignedSource<<975d17d9ffd77aa1c733d1b15e17ad2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionView_viewer$data = {
  readonly nftTokenContractImportById?: {
    readonly errorItems: {
      readonly totalResults: number | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewNftList_contractImport" | "NftProfileImportCollectionView_contractImport">;
  } | null;
  readonly nftTokenContractImportErrors?: {
    readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewNftList_contractImport">;
  } | null;
  readonly publicProfile: {
    readonly username: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionModal_viewer" | "NftProfileImportCollectionViewNftList_viewer" | "NftProfileImportCollectionViewToolbar_viewer">;
  readonly " $fragmentType": "NftProfileImportCollectionView_viewer";
};
export type NftProfileImportCollectionView_viewer$key = {
  readonly " $data"?: NftProfileImportCollectionView_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionView_viewer">;
};

import NftProfileImportCollectionViewRefetchQuery_graphql from './NftProfileImportCollectionViewRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "tokenContractId",
    "variableName": "tokenContractId"
  }
],
v1 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_ERROR"
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "hasTokenContractId"
    },
    {
      "kind": "RootArgument",
      "name": "tokenContractId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "username"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftProfileImportCollectionViewRefetchQuery_graphql
    }
  },
  "name": "NftProfileImportCollectionView_viewer",
  "selections": [
    {
      "condition": "hasTokenContractId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "nftTokenContractImportErrors",
          "args": (v0/*: any*/),
          "concreteType": "NftTokenContractImport",
          "kind": "LinkedField",
          "name": "nftTokenContractImportById",
          "plural": false,
          "selections": [
            {
              "args": [
                (v1/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "NftProfileImportCollectionViewNftList_contractImport"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v0/*: any*/),
          "concreteType": "NftTokenContractImport",
          "kind": "LinkedField",
          "name": "nftTokenContractImportById",
          "plural": false,
          "selections": [
            {
              "alias": "errorItems",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 0
                },
                (v1/*: any*/)
              ],
              "concreteType": "NftTokenContractImportCreatedItemsConnection",
              "kind": "LinkedField",
              "name": "items",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftProfileImportCollectionViewNftList_contractImport"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftProfileImportCollectionView_contractImport"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionViewNftList_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "username",
          "variableName": "username"
        }
      ],
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionViewToolbar_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionModal_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "9e5ba21abd63a05ec3ad42f43d731e88";

export default node;
